const ROUTES = {
  landingPage: "/",
  thankYouLocal: "/thankyou",
};

export default ROUTES;
